import { apiSlice } from "../../apiSlice";

export const userturxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAllTurnsById: builder.mutation({
      query: (parameters) => ({
        url: `/Notifixx/Turnsxxx/${parameters.TURIDXXX}`,
        method: "GET",
        headers: { Modulecima: "Notifixx" },
      }),
    }),
    getGroupsByFilters: builder.query({
      query: (parameters) => ({
        url: `/Notifixx/Turnsxxx/getTurnsById/${parameters}`,
        method: "GET",
        headers: { Modulecima: "Notifixx" },
      }),
    }),
    getDataGraphicGroupsByTurns: builder.query({
      query: (parameters) => ({
        url: `/Notifixx/Turnsxxx/getGroupsByTurns`,
        method: "GET",
        params: parameters.filters,
        headers: { Modulecima: "Notifixx" },
      }),
    }),
    getUserdByTurns: builder.query({
      query: (parameters) => ({
        url: `/Notifixx/Turnsxxx/getUserdByTurns`,
        method: "GET",
        params: parameters.filters,
        headers: { Modulecima: "Notifixx" },
      }),
    }),
  }),
});

export const {
  useGetAllTurnsByIdMutation,
  useLazyGetGroupsByFiltersQuery,
  useLazyGetDataGraphicGroupsByTurnsQuery,
  useLazyGetUserdByTurnsQuery,
} = userturxApiSlice;
